<script>
import simplebar from "simplebar-vue";
import { required } from "vuelidate/lib/validators";
import Pusher from "pusher-js";
/**
 * Chat component
 */
export default {
  name: "ChatAdmin",
  components: { simplebar },
  props: {
    title: {
      type: String,
      default: "Chat"
    },
    chatWindowHeight: {
      type: String,
      default: "367px"
    },
  },
  data() {
    return {
      chats: {
        message: ""
      },
      filter: {
        page: 1,
        per_page: 10,
        orderby: 'created_at',
        sort: 'desc',
        total_page: 0
      },
      chatList: []
    };
  },
  validations: {
    chats: {
      message: { required }
    }
  },
  mounted() {
    this.subscribe()
    this.getListChat()
  },
  updated() {
    let child = document.getElementsByClassName("clearfix");
    if (child && child.length) {
      child[child.length - 1].scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
  },
  methods: {
    subscribe () {
      const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, { cluster: process.env.VUE_APP_PUSHER_CLUSTER })
      pusher.subscribe(`user-${this.$store.state.userdata.id}`)
      pusher.bind('chat-admin', (data) => {
        if (data !== undefined) {
          const checkMessage = this.chatList.findIndex(item => item.id === data.id)
          if (checkMessage < 0) {
            this.chatList.push(data)
          }
        }
      })
    },
    async getListChat() {
      try {
        const response = await this.$axios.get(`/v1/chat_admin`, {
          params: this.filter
        })

        if (response.data.data.rows !== undefined && response.data.data.rows.length > 0) {
          for (let index = 0; index < response.data.data.rows.length; index++) {
            const message = response.data.data.rows[index];
            this.chatList.unshift(message)
          }
          //this.chatList = [...response.data.data.rows, ...this.chatList].reverse()
          this.filter.page = Number(response.data.data.current_page)
          this.filter.per_page = response.data.data.per_page
          this.filter.total_page = Number(response.data.data.total_page)
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    loadMore() {
      if (this.filter.total_page > this.filter.page) {  
        this.filter.page = this.filter.page + 1
        this.getListChat()
      }
    },
    sendMessage() {  
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.$axios.post('/v1/chat_admin', {
          message: this.chats.message
        })
          .then(response => {
            this.chats.message = ""
            this.$v.$reset();
            this.chatList.push(response.data.data)
          })
      }
    },
    uploadAttachment(event) {
      if(event.target.files[0] !== undefined){
        let extension = event.target.files[0].name.split(".").pop()
        let allowedExtention = ['jpg','jpeg','png']
        if(allowedExtention.includes(extension.toLowerCase())){
          let param = new FormData();
          param.append('file', event.target.files[0])
          param.append('status', 'active') 
          param.append('title', event.target.name)
          param.append('description', 'document')

          this.$axios.post('/v1/admin/media', param)
            .then(response => {
              this.$axios.post(`/v1/chat_admin`, {
                file_type: 'image',
                file_path: response.data.data.file
              })
                .then(response => {
                  this.chats.message = ""
                  this.$v.$reset();
                  document.getElementById('attachment').value = null
                  this.chatList.push(response.data.data)
                })
            })

        }else{
          this.document.isUploadError = true
          this.document.errorUploadMessage = "file extentions not allowed"
        }
      }
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-4 border-bawah pb-2">
        <img src="@/assets/images/users/operator.png" alt="male" class="avatar-xs rounded-circle" />
        Admin
      </h4>
      <div class="chat-conversation">
        <ul class="conversation-list" id="messagesContainer" v-scroll="loadMore">
          <simplebar :style="`height:${chatWindowHeight}`">
            <li
              v-for="chat in chatList"
              :key="chat.id"
              :class="{'odd': chat.sender_id === $store.state.userdata.id }"
              class="clearfix"
            >
              <div class="conversation-text">
                <div class="ctext-wrap">
                  <b-img v-if="chat.file_path" fluid style="max-height: 400px" :src="chat.file_path" />
                  <p>{{ chat.message }}</p>
                  <span class="time">{{ chat.created_at | time_only }}</span>
                </div>
              </div>
            </li>
          </simplebar>
        </ul>
      </div>

      <form @submit.prevent="sendMessage">
        <div class="row pt-3">
          <div class="col-sm-8 col-7 chat-inputbar">
            <input
              id="message"
              v-model="chats.message"
              type="text"
              class="form-control chat-input"
              placeholder="Tulis pesan Anda"
              name="message"
              :class="{ 'is-invalid': $v.chats.message.$error }"
            />
            <div
              v-if="!$v.chats.message.required"
              class="invalid-feedback"
            >{{ $t('form.validation.required', { field: 'Pesan' }) }}</div>
          </div>

          <div class="col-sm-1 col-1 chat-send">
            <button type="button" class="btn btn-light btn-block" @click="$refs.attachment.click()">
              <i class="ti-clip"></i>
            </button>
            <input type="file" id="attachment" name="attachment" ref="attachment" @change="uploadAttachment" class="d-none" accept=".jpg, .jpeg, .png" />
          </div>

          <div class="col-sm-3 col-4 chat-send">
            <button type="submit" class="btn btn-danger btn-block">Kirim</button>
          </div>
        </div>
        <!-- end row -->
      </form>
      <!-- end form -->
    </div>
  </div>
</template>